import React, { Fragment } from 'react';

const AppStateContextProviders = ({children}) => (
  <Fragment>
    {children}
  </Fragment>
);

export default AppStateContextProviders;